// ─── Quota de POSSESSION — une seule réponse pour toute l'app ─────
// « Ai-je le droit de créer un élément de plus ? » se posait à trois endroits
// (calendriers, inventaires, plans) et recevait trois réponses différentes.
// Ici la question a UNE réponse, et tout écran qui propose une création la pose.
//
// À ne pas confondre avec les jetons d'AFFICHAGE :
//   • POSSÉDER — borné par `dotation.gestion`. Retirer un élément de la liste
//     des visibles ne libère PAS un droit de création : il faut le supprimer.
//   • AFFICHER — `useJetons().libres` : ce qui reste pour ouvrir un élément de
//     plus à cet instant.
//
// ARBITRAGE quand le comptage n'est pas fiable (une écoute a échoué) :
//   • on NE BLOQUE PAS — cette garde est un confort d'interface, pas une
//     sécurité (le durcissement réel est une Cloud Function). Bloquer sur un
//     doute, c'est interdire à quelqu'un qui a le droit, et c'est le pire des
//     deux résultats ;
//   • mais on N'AFFICHE RIEN — ni compteur, ni « maximum atteint ». Un chiffre
//     faux est pire que pas de chiffre.
// Pendant le chargement (`pret` faux), on retient la création : c'est l'affaire
// de quelques instants et ça évite d'ouvrir sur une liste pas encore arrivée.
import { useJetons } from './useJetons';
import { useNbElementsPossedes, useEtatSourcesElements } from './SourcesElementsContext';

export function useQuotaElements() {
  const { dotation, sansLimite } = useJetons();
  const possedes = useNbElementsPossedes();
  const { pret, erreurs } = useEtatSourcesElements();
  const max = dotation?.gestion || 0;
  const fiable = pret && erreurs.length === 0;
  return {
    possedes,
    max,
    sansLimite,
    pret,
    erreurs,
    fiable,
    peutCreer: sansLimite || (pret && (!fiable || possedes < max)),
    atteint: fiable && !sansLimite && possedes >= max,
  };
}

export default useQuotaElements;
